import { type PdfWatermarkSettings, type PdfWatermarkSettingsRequest, TenantConfigPlane } from '@today/types'
import { apiClient } from './api.client'

/**
 * The watermark route a console plane addresses (TO-495 Contract; TO-632 unified
 * settings tree): the tenant plane is slug-keyed `/t/{slug}/admin/settings/
 * pdf-watermark`, the platform plane is `/admin/tenants/{tenantId}/settings/
 * pdf-watermark`.
 */
const watermarkOf = (tenantId: string, tenantSlug: string, plane: TenantConfigPlane) =>
	plane === TenantConfigPlane.PLATFORM
		? `/admin/tenants/${encodeURIComponent(tenantId)}/settings/pdf-watermark`
		: `/t/${encodeURIComponent(tenantSlug)}/admin/settings/pdf-watermark`

/** A tenant's offer-PDF watermark (TO-495). */
export const pdfSettingsService = {
	/** `GET …/settings/pdf-watermark` — `disabled` when never saved. */
	async getWatermark(tenantId: string, tenantSlug: string, plane: TenantConfigPlane): Promise<PdfWatermarkSettings> {
		const { data } = await apiClient.get<PdfWatermarkSettings>(watermarkOf(tenantId, tenantSlug, plane))
		return data
	},

	/** `PUT …/settings/pdf-watermark` — replaces the whole watermark. */
	async saveWatermark(
		tenantId: string,
		tenantSlug: string,
		plane: TenantConfigPlane,
		body: PdfWatermarkSettingsRequest,
	): Promise<PdfWatermarkSettings> {
		const { data } = await apiClient.put<PdfWatermarkSettings>(watermarkOf(tenantId, tenantSlug, plane), body)
		return data
	},
}
